/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { Box, Typography } from "@mui/material";
import VmVButton from "../components/VmVButtons";
import { ReactComponent as LeftArrow } from "../assets/icons/left-arrow.svg";
import { colors, typography } from "../constants/theme";
import VmVLabel from "../components/VmVLabel";
import { ReactComponent as CSV } from "../assets/icons/csv.svg";
import VmVDataArray from "../components/VmVDataArray";
import {
  CartesianGrid,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../helpers/fetch";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { convertDataToCSV, downloadCSV } from "../helpers/DataToCsv";
import { InscriptionsParticipationsDetailsCells } from "../data/InscriptionsParticipationsDetailsData";
import VmVCalender from "../components/VmVCalender";
import { type ReactNode, useState } from "react";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";

const InscriptionsParticipationsDetails = (): JSX.Element => {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(null);
  const { t } = useTranslation();

  const { data } = useQuery({
    queryKey: ["DatesInscriptions"],
    queryFn: async () =>
      await fetchData(`dates-inscriptions?page=1&pageLimit=10000`),
  });

  const formateData = (): any[] => {
    let reformateData: any[] = [];

    data?.datesInscriptionsList.forEach((element) => {
      reformateData = [
        ...reformateData,
        {
          date: element?.date,
          [t("table.headers.date")]: moment(element?.date).format("DD/MM/YYYY"),
          [t("table.headers.collaboratorsRegistrationsCount")]:
            element?.nombre_collaborateurs,
          [t("table.headers.establishmentSlotsCount")]:
            element?.nombre_etablissements,
        },
      ];
    });

    return reformateData;
  };

  const filterData = (dataToFilter: any[], filter: any): any[] => {
    if (filter === null) return dataToFilter;

    return dataToFilter.filter((element) => {
      const date1 = moment(element.date).format("DD/MM/YYYY");
      const date2 = moment(filter).format("DD/MM/YYYY");
      return date1 === date2;
    });
  };

  const onClickDownloadCSV = (): void => {
    const csvData = convertDataToCSV(formateData());
    downloadCSV(csvData);
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <VmVButton
        onClick={() => {
          navigate(-1);
        }}
        type="back"
        LeftIcon={<LeftArrow stroke={colors.darkGrey[200]} />}
      >
        {t("common.back")}
      </VmVButton>
      <Box
        alignSelf="center"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Typography color={colors.darkBlue} sx={{ ...typography.title1 }}>
          {t("pages.inscriptionsAndParticipations.title")}
        </Typography>
        <InscriptionsParticipationsDetailsChart />
        <Box display="flex" flexDirection="column" gap={8}>
          <Box>
            <Box display="flex" justifyContent="space-between">
              <Box display="flex" gap={1}>
                <VmVButton
                  onClick={() => {
                    setStartDate(null);
                  }}
                  type="primary"
                >
                  {t("common.reset")}
                </VmVButton>
                <VmVCalender
                  date={startDate}
                  handleChangeDate={(date) => {
                    setStartDate(date);
                  }}
                />
              </Box>
              <Box>
                <VmVButton
                  onClick={() => {}}
                  type="secondary"
                  RightIcon={<CSV />}
                >
                  <CSVLink
                    data={formateData()}
                    filename={"data.csv"}
                    style={{
                      color: "inherit",
                      textDecoration: "inherit",
                      fontFamily: "inherit",
                    }}
                    target="_blank"
                  >
                    {t("common.export")}
                  </CSVLink>
                </VmVButton>
              </Box>
            </Box>
          </Box>
          <VmVDataArray
            cells={InscriptionsParticipationsDetailsCells()}
            rows={filterData(formateData(), startDate)}
            showFooter
          />
        </Box>
      </Box>
    </Box>
  );
};

export const InscriptionsParticipationsDetailsChart = ({
  width,
  height,
  home,
}: {
  width?: number;
  height?: number;
  home?: boolean;
}): JSX.Element => {
  const { t } = useTranslation();
  const { data } = useQuery({
    queryKey: ["DatesInscriptions"],
    queryFn: async () =>
      await fetchData(`dates-inscriptions?page=1&pageLimit=10000&sortDate=1`),
  });

  const formateData = (): any[] => {
    // let reformateData: any[] = [];
    let collab: any[] = [];
    let etab: any[] = [];

    data?.datesInscriptionsList.forEach((element, index) => {
      collab = [
        ...collab,
        {
          [t("table.headers.date")]: moment(element?.date).format("DD/MM/YYYY"),
          [t("table.headers.collaboratorsRegistrationsCount")]:
            element?.nombre_collaborateurs,
          [t("table.headers.establishmentSlotsCount")]: null,
        },
      ];
      etab = [
        ...etab,
        {
          [t("table.headers.date")]: moment(element?.date).format("DD/MM/YYYY"),
          [t("table.headers.collaboratorsRegistrationsCount")]: null,
          [t("table.headers.establishmentSlotsCount")]:
            element?.nombre_etablissements,
        },
      ];
    });

    return [
      ...etab,
      {
        [t("table.headers.date")]: null,
        [t("table.headers.collaboratorsRegistrationsCount")]: 0,
        [t("table.headers.establishmentSlotsCount")]: 0,
      },
      ...collab,
    ];
  };

  return (
    <Box
      alignSelf="center"
      display="flex"
      flexDirection="column"
      // gap={2.5}
      mb={home ? 3 : 8}
    >
      <Box mt={home ? 3 : 8} alignSelf="center">
        <LineChart
          width={width ?? 990}
          height={height ?? 500}
          data={formateData()}
        >
          <CartesianGrid strokeDasharray="0 0" />
          <XAxis tick={false} color={colors.darkBlue} width={2} />
          <YAxis tick={false} color={colors.darkBlue} width={2} />
          <Line
            type="monotone"
            dataKey={t("table.headers.establishmentSlotsCount")}
            stroke={colors.orange}
          />
          <Line
            type="monotone"
            dataKey={t("table.headers.collaboratorsRegistrationsCount")}
            stroke={colors.green}
          />
          {home === undefined && <Tooltip content={<CustomTooltip />} />}
        </LineChart>
      </Box>
      <Box display="flex" flexDirection="column" gap={2}>
        <VmVLabel color={colors.green} label={t("common.collaborators")} />
        <VmVLabel color={colors.orange} label={t("common.establishments")} />
      </Box>
    </Box>
  );
};

export default InscriptionsParticipationsDetails;

const CustomTooltip = ({ active, payload, label }: any): JSX.Element | null => {
  const { t } = useTranslation();

  if (active && payload && payload.length) {
    if (payload[0]?.payload[t("table.headers.date")] == null) return null;
    return (
      <div className="custom-tooltip">
        <p>
          {t("table.headers.date")}:{" "}
          {payload[0]?.payload[t("table.headers.date")]}
        </p>
        {payload[0]?.payload[t("table.headers.establishmentSlotsCount")] !==
          null && (
          <p className="etab">
            {t("common.establishments")}:{" "}
            {payload[0]?.payload[t("table.headers.establishmentSlotsCount")]}
          </p>
        )}

        {payload[0]?.payload[
          t("table.headers.collaboratorsRegistrationsCount")
        ] !== null && (
          <p className="collab">
            {t("common.collaborators")}:{" "}
            {
              payload[0]?.payload[
                t("table.headers.collaboratorsRegistrationsCount")
              ]
            }
          </p>
        )}
      </div>
    );
  }
  return null;
};
